<template>
  <div>
    <div class="disp-mob">
      <img src="/assets/images/bn5.png" class="banner">
    </div>
    <div class="iframe-box" style="border: 0">
      <!-- <iframe id="iframe-l" src="//www.minhngoc.net.vn/" frameborder="0" scrolling="no"></iframe> -->
      <img src="@/assets/images/b2021.jpg" style="width: 100%;">
    </div>
    <ResultBox />
    <div class="iframe-box" style="border: 0">
      <!-- <iframe id="iframe-l2" src="//www.minhngoc.net.vn/" frameborder="0" scrolling="no"></iframe> -->
      <a href="https://minhngoctv.com/" target="_blank">
        <img src="@/assets/images/tv550x450.png" style="width: 100%;">
      </a>
    </div>
  </div>
</template>
<script>
import ResultBox from './components/ResultBox.vue'

export default {
  components: {
    ResultBox
  },
  data() {
    return {
      currentDate: null
    }
  },
  created() {
    console.log('pathDate', this.$route.params.pathDate)
  }
}
</script>
<style lang="scss">
.my-result {
  // height: 470px;
  margin-bottom: 10px;
  width: calc(100% - 1px);
  margin: 0 auto;
}
.iframe-box {
  overflow: hidden;
}
#iframe-l {
  overflow: hidden;
  height: 420px;
  margin-left: -210px;
  margin-top: -180px;
  width: 740px;
  max-width: none;
}
</style>
